// import React, { useState, useEffect } from "react";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import "./AdminAttendanceLookup.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faCalendarAlt,
//   faUser,
//   faSearch,
//   faClock,
//   faSignInAlt,
//   faSignOutAlt,
// } from "@fortawesome/free-solid-svg-icons";
// import Layout from "../Layout";

// const BASE_URL = process.env.REACT_APP_BASE_URL;

// const AttendanceLookup = () => {
//   const [employeeId, setEmployeeId] = useState("");
//   const [employeeList, setEmployeeList] = useState([]);
//   const [attendanceRecords, setAttendanceRecords] = useState([]);
//   const [filteredRecords, setFilteredRecords] = useState([]);
//   const [error, setError] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [startDate, setStartDate] = useState(null);
//   const [endDate, setEndDate] = useState(null);
//   const [isFormSubmitted, setIsFormSubmitted] = useState(false);

//   useEffect(() => {
//     const fetchEmployees = async () => {
//       try {
//         const token = sessionStorage.getItem("token");
//         const response = await fetch(`${BASE_URL}/api/employees`, {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         });
//         const data = await response.json();
//         setEmployeeList(data || []);
//       } catch (err) {
//         console.error(err);
//         setError("Error fetching employee list");
//       }
//     };
//     fetchEmployees();
//   }, []);

//   const handleEmployeeIdChange = (event) => {
//     setEmployeeId(event.target.value);
//   };

//   const handleSubmit = async (event) => {
//     event.preventDefault();
//     setError("");
//     setAttendanceRecords([]);
//     setFilteredRecords([]);
//     setIsFormSubmitted(false);

//     if (!startDate || !endDate) {
//       setError("Please choose both start and end dates.");
//       return;
//     }

//     setIsFormSubmitted(true);
//     setLoading(true);

//     try {
//       const token = sessionStorage.getItem("token");
//       if (!token) {
//         setError("No token found, please log in.");
//         setLoading(false);
//         return;
//       }

//       const response = await fetch(
//         `${BASE_URL}/api/attendance/employee/${employeeId}`,
//         {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       if (!response.ok) {
//         if (response.status === 404) {
//           // No records found for this employee
//           setAttendanceRecords([]);
//           setFilteredRecords([]);
//           return;
//         }
//         throw new Error(`Error: ${response.statusText}`);
//       }

//       const data = await response.json();
//       setAttendanceRecords(data || []);
//       filterRecords(data || []);
//     } catch (err) {
//       console.error("Error fetching attendance records:", err);
//       setError("Error fetching attendance records");
//       setAttendanceRecords([]);
//       setFilteredRecords([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const filterRecords = (records) => {
//     let filtered = records;

//     if (startDate && endDate) {
//       const normalizedStartDate = normalizeDate(new Date(startDate));
//       const normalizedEndDate = normalizeDate(new Date(endDate));

//       filtered = filtered.filter((record) => {
//         const checkInDate = normalizeDate(new Date(record.checkInTime));
//         return (
//           checkInDate >= normalizedStartDate && checkInDate <= normalizedEndDate
//         );
//       });
//     }

//     setFilteredRecords(filtered || []);
//   };

//   const normalizeDate = (date) => new Date(date.setHours(0, 0, 0, 0));

//   const handleEndDateChange = (date) => {
//     if (startDate && date < startDate) {
//       setError("End date must be after the start date.");
//     } else {
//       setEndDate(date);
//     }
//   };

//   return (
//     <Layout>
//       <div className="attendance-lookup-container">
//         <div className="attendance-lookup-card">
//           <h2 className="attendance-lookup-title">
//             <FontAwesomeIcon icon={faSearch} className="title-icon" />
//             Attendance Lookup
//           </h2>

//           <form onSubmit={handleSubmit} className="attendance-form">
//             <div className="form-row">
//               <div className="form-group">
//                 <label htmlFor="employeeId" className="form-label">
//                   <FontAwesomeIcon icon={faUser} className="input-icon" />
//                   Select Employee
//                 </label>
//                 <select
//                   id="employeeId"
//                   value={employeeId}
//                   onChange={handleEmployeeIdChange}
//                   required
//                   className="form-select"
//                 >
//                   <option value="">Select an employee</option>
//                   {employeeList.length > 0 &&
//                     employeeList.map((employee) => (
//                       <option
//                         key={employee.employeeid}
//                         value={employee.employeeid}
//                       >
//                         {employee.name} ({employee.employeeid})
//                       </option>
//                     ))}
//                 </select>
//               </div>
//             </div>

//             <div className="form-row date-range-row">
//               <div className="form-group date-group">
//                 <label className="form-label">
//                   <FontAwesomeIcon
//                     icon={faCalendarAlt}
//                     className="input-icon"
//                   />
//                   Start Date
//                 </label>
//                 <DatePicker
//                   selected={startDate}
//                   onChange={(date) => setStartDate(date)}
//                   selectsStart
//                   startDate={startDate}
//                   endDate={endDate}
//                   dateFormat="MMMM d, yyyy"
//                   placeholderText="Select start date"
//                   showMonthDropdown
//                   showYearDropdown
//                   dropdownMode="select"
//                   className="form-date-input"
//                   wrapperClassName="date-picker-wrapper"
//                 />
//               </div>

//               <div className="form-group date-group">
//                 <label className="form-label">
//                   <FontAwesomeIcon
//                     icon={faCalendarAlt}
//                     className="input-icon"
//                   />
//                   End Date
//                 </label>
//                 <DatePicker
//                   selected={endDate}
//                   onChange={handleEndDateChange}
//                   selectsEnd
//                   startDate={startDate}
//                   endDate={endDate}
//                   dateFormat="MMMM d, yyyy"
//                   placeholderText="Select end date"
//                   showMonthDropdown
//                   showYearDropdown
//                   dropdownMode="select"
//                   className="form-date-input"
//                   wrapperClassName="date-picker-wrapper"
//                 />
//               </div>
//             </div>

//             <button
//               type="submit"
//               disabled={loading}
//               className="get-attendence-record-submit-button"
//             >
//               {loading ? (
//                 <span className="loading-text">
//                   <span className="spinner"></span> Loading...
//                 </span>
//               ) : (
//                 <>
//                   <FontAwesomeIcon icon={faSearch} className="button-icon" />
//                   Get Attendance Records
//                 </>
//               )}
//             </button>
//           </form>

//           {error && (
//             <div className="error-message">
//               <p>{error}</p>
//             </div>
//           )}

//           <div className="results-section">
//             {filteredRecords.length > 0 ? (
//               <>
//                 <h3 className="results-title">
//                   Attendance Records ({filteredRecords.length})
//                 </h3>
//                 <div className="records-grid">
//                   {filteredRecords.map((record) => (
//                     <div key={record._id} className="record-card">
//                       <div className="record-date">
//                         {new Date(record.checkInTime).toLocaleDateString(
//                           "en-US",
//                           {
//                             weekday: "short",
//                             year: "numeric",
//                             month: "short",
//                             day: "numeric",
//                           }
//                         )}
//                       </div>
//                       <div className="record-details">
//                         <div className="detail-row">
//                           <FontAwesomeIcon
//                             icon={faSignInAlt}
//                             className="detail-icon"
//                           />
//                           <span className="detail-label">Check-In:</span>
//                           <span className="detail-value">
//                             {new Date(record.checkInTime).toLocaleTimeString()}
//                           </span>
//                         </div>
//                         <div className="detail-row">
//                           <FontAwesomeIcon
//                             icon={faSignOutAlt}
//                             className="detail-icon"
//                           />
//                           <span className="detail-label">Check-Out:</span>
//                           <span className="detail-value">
//                             {record.checkOutTime
//                               ? new Date(
//                                   record.checkOutTime
//                                 ).toLocaleTimeString()
//                               : "Not checked out"}
//                           </span>
//                         </div>
//                         <div className="detail-row">
//                           <FontAwesomeIcon
//                             icon={faClock}
//                             className="detail-icon"
//                           />
//                           <span className="detail-label">Worked:</span>
//                           <span className="detail-value">
//                             {formatWorkingHours(record.workingHours)}
//                           </span>
//                         </div>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </>
//             ) : (
//               isFormSubmitted &&
//               !loading && (
//                 <div className="no-records">
//                   <p>
//                     No attendance records found for the selected employee and
//                     date range.
//                   </p>
//                 </div>
//               )
//             )}
//           </div>
//         </div>
//       </div>
//     </Layout>
//   );
// };

// const formatWorkingHours = (workingHours) => {
//   if (!workingHours) return "N/A";
//   const { hours, minutes, seconds } = workingHours;
//   return `${hours}h ${minutes}m ${seconds}s`;
// };

// export default AttendanceLookup;






















import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./AdminAttendanceLookup.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarAlt,
  faUser,
  faSearch,
  faClock,
  faSignInAlt,
  faSignOutAlt,
} from "@fortawesome/free-solid-svg-icons";
import Layout from "../Layout";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const AttendanceLookup = () => {
  const [employeeId, setEmployeeId] = useState("");
  const [employeeList, setEmployeeList] = useState([]);
  const [attendanceRecords, setAttendanceRecords] = useState([]);
  const [filteredRecords, setFilteredRecords] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [attendanceSummary, setAttendanceSummary] = useState({
    presentDays: 0,
    halfDays: 0,
    totalDays: 0
  });

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const token = sessionStorage.getItem("token");
        const response = await fetch(`${BASE_URL}/api/employees`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        const data = await response.json();
        setEmployeeList(data || []);
      } catch (err) {
        console.error(err);
        setError("Error fetching employee list");
      }
    };
    fetchEmployees();
  }, []);

  const handleEmployeeIdChange = (event) => {
    setEmployeeId(event.target.value);
  };

  const calculateAttendanceSummary = (records) => {
    let presentDays = 0;
    let halfDays = 0;
    
    records.forEach(record => {
      if (record.workingHours) {
        const totalHours = record.workingHours.hours + 
                          (record.workingHours.minutes / 60) + 
                          (record.workingHours.seconds / 3600);
        
        if (totalHours >= 8) {
          presentDays++;
        } else if (totalHours >= 4) {
          halfDays++;
        }
      }
    });
    
    return {
      presentDays,
      halfDays,
      totalDays: records.length
    };
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setAttendanceRecords([]);
    setFilteredRecords([]);
    setIsFormSubmitted(false);

    if (!startDate || !endDate) {
      setError("Please choose both start and end dates.");
      return;
    }

    setIsFormSubmitted(true);
    setLoading(true);

    try {
      const token = sessionStorage.getItem("token");
      if (!token) {
        setError("No token found, please log in.");
        setLoading(false);
        return;
      }

      const response = await fetch(
        `${BASE_URL}/api/attendance/employee/${employeeId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        if (response.status === 404) {
          // No records found for this employee
          setAttendanceRecords([]);
          setFilteredRecords([]);
          setAttendanceSummary({
            presentDays: 0,
            halfDays: 0,
            totalDays: 0
          });
          return;
        }
        throw new Error(`Error: ${response.statusText}`);
      }

      const data = await response.json();
      setAttendanceRecords(data || []);
      filterRecords(data || []);
    } catch (err) {
      console.error("Error fetching attendance records:", err);
      setError("Error fetching attendance records");
      setAttendanceRecords([]);
      setFilteredRecords([]);
      setAttendanceSummary({
        presentDays: 0,
        halfDays: 0,
        totalDays: 0
      });
    } finally {
      setLoading(false);
    }
  };

  const filterRecords = (records) => {
    let filtered = records;

    if (startDate && endDate) {
      const normalizedStartDate = normalizeDate(new Date(startDate));
      const normalizedEndDate = normalizeDate(new Date(endDate));

      filtered = filtered.filter((record) => {
        const checkInDate = normalizeDate(new Date(record.checkInTime));
        return (
          checkInDate >= normalizedStartDate && checkInDate <= normalizedEndDate
        );
      });
    }

    setFilteredRecords(filtered || []);
    setAttendanceSummary(calculateAttendanceSummary(filtered || []));
  };

  const normalizeDate = (date) => new Date(date.setHours(0, 0, 0, 0));

  const handleEndDateChange = (date) => {
    if (startDate && date < startDate) {
      setError("End date must be after the start date.");
    } else {
      setEndDate(date);
    }
  };

  return (
    <Layout>
      <div className="attendance-lookup-container">
        <div className="attendance-lookup-card">
          <h2 className="attendance-lookup-title">
            <FontAwesomeIcon icon={faSearch} className="title-icon" />
            Attendance Lookup
          </h2>

          <form onSubmit={handleSubmit} className="attendance-form">
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="employeeId" className="form-label">
                  <FontAwesomeIcon icon={faUser} className="input-icon" />
                  Select Employee
                </label>
                <select
                  id="employeeId"
                  value={employeeId}
                  onChange={handleEmployeeIdChange}
                  required
                  className="form-select"
                >
                  <option value="">Select an employee</option>
                  {employeeList.length > 0 &&
                    employeeList.map((employee) => (
                      <option
                        key={employee.employeeid}
                        value={employee.employeeid}
                      >
                        {employee.name} ({employee.employeeid})
                      </option>
                    ))}
                </select>
              </div>
            </div>

            <div className="form-row date-range-row">
              <div className="form-group date-group">
                <label className="form-label">
                  <FontAwesomeIcon
                    icon={faCalendarAlt}
                    className="input-icon"
                  />
                  Start Date
                </label>
                <DatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  selectsStart
                  startDate={startDate}
                  endDate={endDate}
                  dateFormat="MMMM d, yyyy"
                  placeholderText="Select start date"
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  className="form-date-input"
                  wrapperClassName="date-picker-wrapper"
                />
              </div>

              <div className="form-group date-group">
                <label className="form-label">
                  <FontAwesomeIcon
                    icon={faCalendarAlt}
                    className="input-icon"
                  />
                  End Date
                </label>
                <DatePicker
                  selected={endDate}
                  onChange={handleEndDateChange}
                  selectsEnd
                  startDate={startDate}
                  endDate={endDate}
                  dateFormat="MMMM d, yyyy"
                  placeholderText="Select end date"
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  className="form-date-input"
                  wrapperClassName="date-picker-wrapper"
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="get-attendence-record-submit-button"
            >
              {loading ? (
                <span className="loading-text">
                  <span className="spinner"></span> Loading...
                </span>
              ) : (
                <>
                  <FontAwesomeIcon icon={faSearch} className="button-icon" />
                  Get Attendance Records
                </>
              )}
            </button>
          </form>

          {error && (
            <div className="error-message">
              <p>{error}</p>
            </div>
          )}

          <div className="results-section">
            {filteredRecords.length > 0 ? (
              <>
                {/* <div className="attendance-summary">
                  <h3 className="summary-title">Attendance Summary</h3>
                  <div className="summary-grid">
                    <div className="summary-item">
                      <span className="summary-label">Total Days:</span>
                      <span className="summary-value">{attendanceSummary.totalDays}</span>
                    </div>
                    <div className="summary-item">
                      <span className="summary-label">Present Days:</span>
                      <span className="summary-value">{attendanceSummary.presentDays}</span>
                    </div>
                    <div className="summary-item">
                      <span className="summary-label">Half Days:</span>
                      <span className="summary-value">{attendanceSummary.halfDays}</span>
                    </div>
                  </div>
                </div> */}

                 <div className="attendance-summary-single-line">
                  {/* <h3 className="summary-title">Attendance Summary:</h3> */}
                  <p className="summary-data-bold">
                    <strong>
                      Total Days: {attendanceSummary.totalDays} | 
                      Present Days: {attendanceSummary.presentDays} | 
                      Half Days: {attendanceSummary.halfDays}
                    </strong>
                  </p>
                </div>

                <h3 className="results-title">
                  Attendance Records ({filteredRecords.length})
                </h3>
                {/* <div className="records-grid"> */}
                                <div className="records-list-single-line">
                  {filteredRecords.map((record) => {
                    const totalHours = record.workingHours 
                      ? record.workingHours.hours + 
                        (record.workingHours.minutes / 60) + 
                        (record.workingHours.seconds / 3600)
                      : 0;
                    const dayStatus = totalHours >= 8 ? "present" : 
                                    totalHours >= 4 ? "half-day" : "absent";

                    return (
                      <div key={record._id} className={`record-card ${dayStatus}`}>
                        {/* <div className="record-date">
                          {new Date(record.checkInTime).toLocaleDateString(
                            "en-US",
                            {
                              weekday: "short",
                              year: "numeric",
                              month: "short",
                              day: "numeric",
                            }
                          )}
                          <span className={`day-status ${dayStatus}`}>
                            {dayStatus === "present" ? "Present" : 
                             dayStatus === "half-day" ? "Half Day" : "Absent"}
                          </span>
                        </div>
                        <div className="record-details">
                          <div className="detail-row">
                            <FontAwesomeIcon
                              icon={faSignInAlt}
                              className="detail-icon"
                            />
                            <span className="detail-label">Check-In:</span>
                            <span className="detail-value">
                              {new Date(record.checkInTime).toLocaleTimeString()}
                            </span>
                          </div>
                          <div className="detail-row">
                            <FontAwesomeIcon
                              icon={faSignOutAlt}
                              className="detail-icon"
                            />
                            <span className="detail-label">Check-Out:</span>
                            <span className="detail-value">
                              {record.checkOutTime
                                ? new Date(
                                    record.checkOutTime
                                  ).toLocaleTimeString()
                                : "Not checked out"}
                            </span>
                          </div>
                          <div className="detail-row">
                            <FontAwesomeIcon
                              icon={faClock}
                              className="detail-icon"
                            />
                            <span className="detail-label">Worked:</span>
                            <span className="detail-value">
                              {formatWorkingHours(record.workingHours)}
                            </span>
                          </div>
                        </div> */}
                          <p className="record-data-bold">
                          <strong>
                            {new Date(record.checkInTime).toLocaleDateString("en-US", {
                              year: 'numeric',
                              month: 'short',
                              day: 'numeric',
                              weekday: 'short'
                            })} | 
                            Status: {dayStatus} | 
                            Check-In: {new Date(record.checkInTime).toLocaleTimeString()}
                            {record.checkInSource === "outside" ? " (Outside" + (record.checkInLocation ? `: ${record.checkInLocation}` : "") + ")" : ""} | 
                            Check-Out: {record.checkOutTime ? new Date(record.checkOutTime).toLocaleTimeString() : "N/A"}
                            {record.checkOutSource === "outside" ? " (Outside" + (record.checkOutLocation ? `: ${record.checkOutLocation}` : "") + ")" : ""} | 
                            Worked: {formatWorkingHours(record.workingHours)}
                          </strong>
                        </p>
                        {((record.checkInSource === "outside" && (record.checkInReason || record.checkInLocation)) || (record.checkOutSource === "outside" && (record.checkOutReason || record.checkOutLocation))) && (
                          <p className="record-data-bold" style={{ fontSize: "12px", color: "#666", marginTop: "4px" }}>
                            {record.checkInSource === "outside" && (record.checkInReason || record.checkInLocation) && (
                              <>Check-in: {[record.checkInLocation, record.checkInReason].filter(Boolean).join(" — ")}</>
                            )}
                            {record.checkInSource === "outside" && record.checkOutSource === "outside" && (record.checkOutReason || record.checkOutLocation) && " | "}
                            {record.checkOutSource === "outside" && (record.checkOutReason || record.checkOutLocation) && (
                              <>Check-out: {[record.checkOutLocation, record.checkOutReason].filter(Boolean).join(" — ")}</>
                            )}
                          </p>
                        )}
                      </div>
                    );
                  })}
                </div>
              </>
            ) : (
              isFormSubmitted &&
              !loading && (
                <div className="no-records">
                  <p>
                    No attendance records found for the selected employee and
                    date range.
                  </p>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

const formatWorkingHours = (workingHours) => {
  if (!workingHours) return "N/A";
  const { hours, minutes, seconds } = workingHours;
  return `${hours}h ${minutes}m ${seconds}s`;
};

export default AttendanceLookup;